webpackJsonp([4],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Modified to Typescript
// Converted to non-binary search as text-sizes may not always be "linearish"
/**
 * textFit v2.3.1
 * Previously known as jQuery.textFit
 * 11/2014 by STRML (strml.github.com)
 * MIT License
 *
 * To use: textFit(document.getElementById('target-div'), options);
 *
 * Will make the *text* content inside a container scale to fit the container
 * The container is required to have a set width and height
 * Uses binary search to fit text with minimal layout calls.
 * Version 2.0 does not use jQuery.
 */
/*global define:true, document:true, window:true, HTMLElement:true*/

Object.defineProperty(exports, "__esModule", { value: true });
exports.textFit = void 0;
var defaultSettings = {
    alignVert: false,
    alignHoriz: false,
    multiLine: false,
    detectMultiLine: true,
    minFontSize: 6,
    maxFontSize: 80,
    reProcess: true,
    widthOnly: false,
    alignVertWithFlexbox: false,
};
function textFit(els, options) {
    if (!options)
        options = {};
    // Extend options.
    var settings = {};
    for (var key in defaultSettings) {
        if (options.hasOwnProperty(key)) {
            settings[key] = options[key];
        }
        else {
            settings[key] = defaultSettings[key];
        }
    }
    // Process each el we've passed.
    for (var i = 0; i < els.length; i++) {
        processItem(els[i], settings);
    }
}
exports.textFit = textFit;
;
/**
 * The meat. Given an el, make the text inside it fit its parent.
 * @param  {DOMElement} el       Child el.
 * @param  {Object} settings     Options for fit.
 */
function processItem(el, settings) {
    if (!isElement(el) || (!settings.reProcess && el.getAttribute('textFitted'))) {
        return false;
    }
    // Set textFitted attribute so we know this was processed.
    if (!settings.reProcess) {
        el.setAttribute('textFitted', 1);
    }
    var innerSpan, originalHeight, originalHTML, originalWidth;
    var low, mid, high;
    // Get element data.
    originalHTML = el.innerHTML;
    originalWidth = intInnerWidth(el);
    originalHeight = intInnerHeight(el);
    // Don't process if we can't find box dimensions
    if (!originalWidth || (!settings.widthOnly && !originalHeight)) {
        if (!settings.widthOnly)
            throw new Error('Set a static height and width on the target element ' + el.outerHTML +
                ' before using textFit!');
        else
            throw new Error('Set a static width on the target element ' + el.outerHTML +
                ' before using textFit!');
    }
    // Add textFitted span inside this container.
    if (originalHTML.indexOf('textFitted') === -1) {
        innerSpan = document.createElement('span');
        innerSpan.className = 'textFitted';
        // Inline block ensure it takes on the size of its contents, even if they are enclosed
        // in other tags like <p>
        innerSpan.style['display'] = 'inline-block';
        innerSpan.innerHTML = originalHTML;
        el.innerHTML = '';
        el.appendChild(innerSpan);
    }
    else {
        // Reprocessing.
        innerSpan = el.querySelector('span.textFitted');
        // Remove vertical align if we're reprocessing.
        if (hasClass(innerSpan, 'textFitAlignVert')) {
            innerSpan.className = innerSpan.className.replace('textFitAlignVert', '');
            innerSpan.style['height'] = '';
            el.className.replace('textFitAlignVertFlex', '');
        }
    }
    // Prepare & set alignment
    if (settings.alignHoriz) {
        el.style['text-align'] = 'center';
        innerSpan.style['text-align'] = 'center';
    }
    // Check if this string is multiple lines
    // Not guaranteed to always work if you use wonky line-heights
    var multiLine = settings.multiLine;
    if (settings.detectMultiLine && !multiLine &&
        innerSpan.scrollHeight >= parseInt(window.getComputedStyle(innerSpan)['font-size'], 10) * 2) {
        multiLine = true;
    }
    // If we're not treating this as a multiline string, don't let it wrap.
    if (!multiLine) {
        el.style['white-space'] = 'nowrap';
    }
    low = settings.minFontSize + 1;
    high = settings.maxFontSize + 1;
    mid = low;
    var step = 0.33;
    // Linear search 
    while (low <= high) {
        innerSpan.style.fontSize = mid + 'px';
        if (innerSpan.scrollWidth <= originalWidth && (settings.widthOnly || innerSpan.scrollHeight <= originalHeight)) {
            mid = mid + step;
        }
        else {
            break;
        }
    }
    // Sub 1 at the very end, this is closer to what we wanted.
    innerSpan.style.fontSize = (mid - step) + 'px';
    // Our height is finalized. If we are aligning vertically, set that up.
    if (settings.alignVert) {
        addStyleSheet();
        var height = innerSpan.scrollHeight;
        if (window.getComputedStyle(el)['position'] === "static") {
            el.style['position'] = 'relative';
        }
        if (!hasClass(innerSpan, "textFitAlignVert")) {
            innerSpan.className = innerSpan.className + " textFitAlignVert";
        }
        innerSpan.style['height'] = height + "px";
        if (settings.alignVertWithFlexbox && !hasClass(el, "textFitAlignVertFlex")) {
            el.className = el.className + " textFitAlignVertFlex";
        }
    }
}
// Calculate height without padding.
function intInnerHeight(el) {
    var style = window.getComputedStyle(el, null);
    return el.clientHeight -
        parseInt(style.getPropertyValue('padding-top'), 10) -
        parseInt(style.getPropertyValue('padding-bottom'), 10);
}
// Calculate width without padding.
function intInnerWidth(el) {
    var style = window.getComputedStyle(el, null);
    return el.clientWidth -
        parseInt(style.getPropertyValue('padding-left'), 10) -
        parseInt(style.getPropertyValue('padding-right'), 10);
}
//Returns true if it is a DOM element
function isElement(o) {
    return (typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
        o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string");
}
function hasClass(element, cls) {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}
// Better than a stylesheet dependency
function addStyleSheet() {
    if (document.getElementById("textFitStyleSheet"))
        return;
    var style = [
        ".textFitAlignVert{",
        "position: absolute;",
        "top: 0; right: 0; bottom: 0; left: 0;",
        "margin: auto;",
        "display: flex;",
        "justify-content: center;",
        "flex-direction: column;",
        "}",
        ".textFitAlignVertFlex{",
        "display: flex;",
        "}",
        ".textFitAlignVertFlex .textFitAlignVert{",
        "position: static;",
        "}",
    ].join("");
    var css = document.createElement("style");
    css.type = "text/css";
    css.id = "textFitStyleSheet";
    css.innerHTML = style;
    document.body.appendChild(css);
}


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(16)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(14),
  /* scopeId */
  "data-v-ddf0b578",
  /* cssModules */
  null
)

exports.__esModule = true;
exports["default"] = Component.exports


/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(15)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(13),
  /* scopeId */
  "data-v-420c1582",
  /* cssModules */
  null
)

exports.__esModule = true;
exports["default"] = Component.exports


/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row small-up-2 medium-up-3 large-up-3 grid"
  }, _vm._l((_vm.faces), function(face) {
    return _c('div', {
      staticClass: "column column-block"
    }, [_c('face', {
      attrs: {
        "face": face,
        "title-description": _vm.titleDescription
      }
    })], 1)
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: _vm.popupActive ? 'popupActive' : ''
  }, [(_vm.popupActive) ? _c('a', {
    staticClass: "close button",
    on: {
      "click": function($event) {
        _vm.popupActive = false
      }
    }
  }, [_vm._v("Close X")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "title top"
  }, [_vm._v("\n    " + _vm._s(_vm.face.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "face"
  }, [_c('div', {
    staticClass: "imgContainer"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.face.imageName),
      expression: "face.imageName"
    }],
    on: {
      "click": function($event) {
        _vm.popupActive = !_vm.popupActive
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "description",
    class: _vm.titleDescription ? 'titleDescription' : ''
  }, [_vm._v("\n      " + _vm._s(_vm.face.description) + "\n    ")])]), _vm._v(" "), _c('p', {
    staticClass: "title bottom"
  }, [_vm._v("\n    " + _vm._s(_vm.face.title) + "\n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Derick2018.2d991d4.jpg";

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("8bdd1916", content, true);

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("03adddf8", content, true);

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(228)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(223),
  /* scopeId */
  "data-v-0006bcf7",
  /* cssModules */
  null
)

exports.__esModule = true;
exports["default"] = Component.exports


/***/ }),

/***/ 223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('face-block-grid', {
    attrs: {
      "faces": _vm.faces,
      "title-description": false
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(33);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6950f482", content, true);

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_lazyload__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InLovingMemory__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InLovingMemory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InLovingMemory__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_lazyload___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#in_loving_memory',
  template: '<InLovingMemory/>',
  components: { InLovingMemory: __WEBPACK_IMPORTED_MODULE_2__InLovingMemory___default.a }
});

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FaceBlockGrid__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FaceBlockGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FaceBlockGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_in_loving_memory_ts__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_in_loving_memory_ts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_in_loving_memory_ts__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'in_loving_memory',
  components: { FaceBlockGrid: __WEBPACK_IMPORTED_MODULE_0__components_FaceBlockGrid___default.a },
  data: function data() {
    return {
      faces: __WEBPACK_IMPORTED_MODULE_1__data_in_loving_memory_ts___default.a
    };
  }
});

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".container[data-v-0006bcf7]{margin-left:auto;margin-right:auto;max-width:62.5rem}", ""]);

// exports


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Faces = void 0;
exports.Faces = [
    {
        "title": "Derick",
        "description": "Derick was a university student from Bubugo village studying motor vehicle engineering. Sadly, in 2021 he passed away unexpectedly. He is deeply missed and he will forever be remembered in BSSP.",
        "imageName": __webpack_require__(144)
    },
];
exports.default = exports.Faces;


/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "/*! normalize-scss | MIT/GPLv2 License | bit.ly/normalize-scss */html[data-v-420c1582]{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}article[data-v-420c1582],aside[data-v-420c1582],footer[data-v-420c1582],header[data-v-420c1582],nav[data-v-420c1582],section[data-v-420c1582]{display:block}h1[data-v-420c1582]{font-size:2em;margin:.67em 0}figcaption[data-v-420c1582],figure[data-v-420c1582]{display:block}figure[data-v-420c1582]{margin:1em 40px}hr[data-v-420c1582]{box-sizing:content-box;height:0;overflow:visible}main[data-v-420c1582]{display:block}pre[data-v-420c1582]{font-family:monospace,monospace;font-size:1em}a[data-v-420c1582]{background-color:transparent;-webkit-text-decoration-skip:objects}a[data-v-420c1582]:active,a[data-v-420c1582]:hover{outline-width:0}abbr[title][data-v-420c1582]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b[data-v-420c1582],strong[data-v-420c1582]{font-weight:inherit;font-weight:bolder}code[data-v-420c1582],kbd[data-v-420c1582],samp[data-v-420c1582]{font-family:monospace,monospace;font-size:1em}dfn[data-v-420c1582]{font-style:italic}mark[data-v-420c1582]{background-color:#ff0;color:#000}small[data-v-420c1582]{font-size:80%}sub[data-v-420c1582],sup[data-v-420c1582]{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub[data-v-420c1582]{bottom:-.25em}sup[data-v-420c1582]{top:-.5em}audio[data-v-420c1582],video[data-v-420c1582]{display:inline-block}audio[data-v-420c1582]:not([controls]){display:none;height:0}img[data-v-420c1582]{border-style:none}svg[data-v-420c1582]:not(:root){overflow:hidden}button[data-v-420c1582],input[data-v-420c1582],optgroup[data-v-420c1582],select[data-v-420c1582],textarea[data-v-420c1582]{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button[data-v-420c1582]{overflow:visible}button[data-v-420c1582],select[data-v-420c1582]{text-transform:none}[type=reset][data-v-420c1582],[type=submit][data-v-420c1582],button[data-v-420c1582],html [type=button][data-v-420c1582]{-webkit-appearance:button}[type=button][data-v-420c1582]::-moz-focus-inner,[type=reset][data-v-420c1582]::-moz-focus-inner,[type=submit][data-v-420c1582]::-moz-focus-inner,button[data-v-420c1582]::-moz-focus-inner{border-style:none;padding:0}[type=button][data-v-420c1582]:-moz-focusring,[type=reset][data-v-420c1582]:-moz-focusring,[type=submit][data-v-420c1582]:-moz-focusring,button[data-v-420c1582]:-moz-focusring{outline:1px dotted ButtonText}input[data-v-420c1582]{overflow:visible}[type=checkbox][data-v-420c1582],[type=radio][data-v-420c1582]{box-sizing:border-box;padding:0}[type=number][data-v-420c1582]::-webkit-inner-spin-button,[type=number][data-v-420c1582]::-webkit-outer-spin-button{height:auto}[type=search][data-v-420c1582]{-webkit-appearance:textfield;outline-offset:-2px}[type=search][data-v-420c1582]::-webkit-search-cancel-button,[type=search][data-v-420c1582]::-webkit-search-decoration{-webkit-appearance:none}[data-v-420c1582]::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}fieldset[data-v-420c1582]{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend[data-v-420c1582]{box-sizing:border-box;display:table;max-width:100%;padding:0;color:inherit;white-space:normal}progress[data-v-420c1582]{display:inline-block;vertical-align:baseline}textarea[data-v-420c1582]{overflow:auto}details[data-v-420c1582]{display:block}summary[data-v-420c1582]{display:list-item}menu[data-v-420c1582]{display:block}canvas[data-v-420c1582]{display:inline-block}[hidden][data-v-420c1582],template[data-v-420c1582]{display:none}.foundation-mq[data-v-420c1582]{font-family:\"small=0em&medium=40em&large=64em&xlarge=75em&xxlarge=90em\"}html[data-v-420c1582]{box-sizing:border-box;font-size:100%}[data-v-420c1582],[data-v-420c1582]:after,[data-v-420c1582]:before{box-sizing:inherit}body[data-v-420c1582]{margin:0;padding:0;background:#fefefe;font-family:Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;line-height:1.5;color:#0a0a0a;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}img[data-v-420c1582]{display:inline-block;vertical-align:middle;max-width:100%;height:auto;-ms-interpolation-mode:bicubic}textarea[data-v-420c1582]{height:auto;min-height:50px;border-radius:0}select[data-v-420c1582]{box-sizing:border-box;width:100%;border-radius:0}.map_canvas embed[data-v-420c1582],.map_canvas img[data-v-420c1582],.map_canvas object[data-v-420c1582],.mqa-display embed[data-v-420c1582],.mqa-display img[data-v-420c1582],.mqa-display object[data-v-420c1582]{max-width:none!important}button[data-v-420c1582]{padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;border-radius:0;background:transparent;line-height:1;cursor:auto}[data-whatinput=mouse] button[data-v-420c1582]{outline:0}pre[data-v-420c1582]{overflow:auto}button[data-v-420c1582],input[data-v-420c1582],optgroup[data-v-420c1582],select[data-v-420c1582],textarea[data-v-420c1582]{font-family:inherit}.is-visible[data-v-420c1582]{display:block!important}.is-hidden[data-v-420c1582]{display:none!important}.row[data-v-420c1582]{max-width:75rem;margin-right:auto;margin-left:auto}.row[data-v-420c1582]:after,.row[data-v-420c1582]:before{display:table;content:\" \";-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-order:1;order:1}.row[data-v-420c1582]:after{clear:both}.row.collapse>.column[data-v-420c1582],.row.collapse>.columns[data-v-420c1582]{padding-right:0;padding-left:0}.row .row[data-v-420c1582]{margin-right:-.625rem;margin-left:-.625rem}@media print,screen and (min-width:40em){.row .row[data-v-420c1582]{margin-right:-.9375rem;margin-left:-.9375rem}}@media print,screen and (min-width:64em){.row .row[data-v-420c1582]{margin-right:-.9375rem;margin-left:-.9375rem}}.row .row.collapse[data-v-420c1582]{margin-right:0;margin-left:0}.row.expanded[data-v-420c1582]{max-width:none}.row.expanded .row[data-v-420c1582]{margin-right:auto;margin-left:auto}.row:not(.expanded) .row[data-v-420c1582]{max-width:none}.row.gutter-small>.column[data-v-420c1582],.row.gutter-small>.columns[data-v-420c1582]{padding-right:.625rem;padding-left:.625rem}.row.gutter-medium>.column[data-v-420c1582],.row.gutter-medium>.columns[data-v-420c1582]{padding-right:.9375rem;padding-left:.9375rem}.column[data-v-420c1582],.columns[data-v-420c1582]{width:100%;float:left;padding-right:.625rem;padding-left:.625rem}@media print,screen and (min-width:40em){.column[data-v-420c1582],.columns[data-v-420c1582]{padding-right:.9375rem;padding-left:.9375rem}}.column[data-v-420c1582]:last-child:not(:first-child),.columns[data-v-420c1582]:last-child:not(:first-child){float:right}.column.end[data-v-420c1582]:last-child:last-child,.end.columns[data-v-420c1582]:last-child:last-child{float:left}.column.row.row[data-v-420c1582],.row.row.columns[data-v-420c1582]{float:none}.row .column.row.row[data-v-420c1582],.row .row.row.columns[data-v-420c1582]{margin-right:0;margin-left:0;padding-right:0;padding-left:0}.small-1[data-v-420c1582]{width:8.33333%}.small-push-1[data-v-420c1582]{position:relative;left:8.33333%}.small-pull-1[data-v-420c1582]{position:relative;left:-8.33333%}.small-offset-0[data-v-420c1582]{margin-left:0}.small-2[data-v-420c1582]{width:16.66667%}.small-push-2[data-v-420c1582]{position:relative;left:16.66667%}.small-pull-2[data-v-420c1582]{position:relative;left:-16.66667%}.small-offset-1[data-v-420c1582]{margin-left:8.33333%}.small-3[data-v-420c1582]{width:25%}.small-push-3[data-v-420c1582]{position:relative;left:25%}.small-pull-3[data-v-420c1582]{position:relative;left:-25%}.small-offset-2[data-v-420c1582]{margin-left:16.66667%}.small-4[data-v-420c1582]{width:33.33333%}.small-push-4[data-v-420c1582]{position:relative;left:33.33333%}.small-pull-4[data-v-420c1582]{position:relative;left:-33.33333%}.small-offset-3[data-v-420c1582]{margin-left:25%}.small-5[data-v-420c1582]{width:41.66667%}.small-push-5[data-v-420c1582]{position:relative;left:41.66667%}.small-pull-5[data-v-420c1582]{position:relative;left:-41.66667%}.small-offset-4[data-v-420c1582]{margin-left:33.33333%}.small-6[data-v-420c1582]{width:50%}.small-push-6[data-v-420c1582]{position:relative;left:50%}.small-pull-6[data-v-420c1582]{position:relative;left:-50%}.small-offset-5[data-v-420c1582]{margin-left:41.66667%}.small-7[data-v-420c1582]{width:58.33333%}.small-push-7[data-v-420c1582]{position:relative;left:58.33333%}.small-pull-7[data-v-420c1582]{position:relative;left:-58.33333%}.small-offset-6[data-v-420c1582]{margin-left:50%}.small-8[data-v-420c1582]{width:66.66667%}.small-push-8[data-v-420c1582]{position:relative;left:66.66667%}.small-pull-8[data-v-420c1582]{position:relative;left:-66.66667%}.small-offset-7[data-v-420c1582]{margin-left:58.33333%}.small-9[data-v-420c1582]{width:75%}.small-push-9[data-v-420c1582]{position:relative;left:75%}.small-pull-9[data-v-420c1582]{position:relative;left:-75%}.small-offset-8[data-v-420c1582]{margin-left:66.66667%}.small-10[data-v-420c1582]{width:83.33333%}.small-push-10[data-v-420c1582]{position:relative;left:83.33333%}.small-pull-10[data-v-420c1582]{position:relative;left:-83.33333%}.small-offset-9[data-v-420c1582]{margin-left:75%}.small-11[data-v-420c1582]{width:91.66667%}.small-push-11[data-v-420c1582]{position:relative;left:91.66667%}.small-pull-11[data-v-420c1582]{position:relative;left:-91.66667%}.small-offset-10[data-v-420c1582]{margin-left:83.33333%}.small-12[data-v-420c1582]{width:100%}.small-offset-11[data-v-420c1582]{margin-left:91.66667%}.small-up-1>.column[data-v-420c1582],.small-up-1>.columns[data-v-420c1582]{float:left;width:100%}.small-up-1>.column[data-v-420c1582]:nth-of-type(1n),.small-up-1>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.small-up-1>.column[data-v-420c1582]:nth-of-type(1n+1),.small-up-1>.columns[data-v-420c1582]:nth-of-type(1n+1){clear:both}.small-up-1>.column[data-v-420c1582]:last-child,.small-up-1>.columns[data-v-420c1582]:last-child{float:left}.small-up-2>.column[data-v-420c1582],.small-up-2>.columns[data-v-420c1582]{float:left;width:50%}.small-up-2>.column[data-v-420c1582]:nth-of-type(1n),.small-up-2>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.small-up-2>.column[data-v-420c1582]:nth-of-type(odd),.small-up-2>.columns[data-v-420c1582]:nth-of-type(odd){clear:both}.small-up-2>.column[data-v-420c1582]:last-child,.small-up-2>.columns[data-v-420c1582]:last-child{float:left}.small-up-3>.column[data-v-420c1582],.small-up-3>.columns[data-v-420c1582]{float:left;width:33.33333%}.small-up-3>.column[data-v-420c1582]:nth-of-type(1n),.small-up-3>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.small-up-3>.column[data-v-420c1582]:nth-of-type(3n+1),.small-up-3>.columns[data-v-420c1582]:nth-of-type(3n+1){clear:both}.small-up-3>.column[data-v-420c1582]:last-child,.small-up-3>.columns[data-v-420c1582]:last-child{float:left}.small-up-4>.column[data-v-420c1582],.small-up-4>.columns[data-v-420c1582]{float:left;width:25%}.small-up-4>.column[data-v-420c1582]:nth-of-type(1n),.small-up-4>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.small-up-4>.column[data-v-420c1582]:nth-of-type(4n+1),.small-up-4>.columns[data-v-420c1582]:nth-of-type(4n+1){clear:both}.small-up-4>.column[data-v-420c1582]:last-child,.small-up-4>.columns[data-v-420c1582]:last-child{float:left}.small-up-5>.column[data-v-420c1582],.small-up-5>.columns[data-v-420c1582]{float:left;width:20%}.small-up-5>.column[data-v-420c1582]:nth-of-type(1n),.small-up-5>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.small-up-5>.column[data-v-420c1582]:nth-of-type(5n+1),.small-up-5>.columns[data-v-420c1582]:nth-of-type(5n+1){clear:both}.small-up-5>.column[data-v-420c1582]:last-child,.small-up-5>.columns[data-v-420c1582]:last-child{float:left}.small-up-6>.column[data-v-420c1582],.small-up-6>.columns[data-v-420c1582]{float:left;width:16.66667%}.small-up-6>.column[data-v-420c1582]:nth-of-type(1n),.small-up-6>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.small-up-6>.column[data-v-420c1582]:nth-of-type(6n+1),.small-up-6>.columns[data-v-420c1582]:nth-of-type(6n+1){clear:both}.small-up-6>.column[data-v-420c1582]:last-child,.small-up-6>.columns[data-v-420c1582]:last-child{float:left}.small-up-7>.column[data-v-420c1582],.small-up-7>.columns[data-v-420c1582]{float:left;width:14.28571%}.small-up-7>.column[data-v-420c1582]:nth-of-type(1n),.small-up-7>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.small-up-7>.column[data-v-420c1582]:nth-of-type(7n+1),.small-up-7>.columns[data-v-420c1582]:nth-of-type(7n+1){clear:both}.small-up-7>.column[data-v-420c1582]:last-child,.small-up-7>.columns[data-v-420c1582]:last-child{float:left}.small-up-8>.column[data-v-420c1582],.small-up-8>.columns[data-v-420c1582]{float:left;width:12.5%}.small-up-8>.column[data-v-420c1582]:nth-of-type(1n),.small-up-8>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.small-up-8>.column[data-v-420c1582]:nth-of-type(8n+1),.small-up-8>.columns[data-v-420c1582]:nth-of-type(8n+1){clear:both}.small-up-8>.column[data-v-420c1582]:last-child,.small-up-8>.columns[data-v-420c1582]:last-child{float:left}.small-collapse>.column[data-v-420c1582],.small-collapse>.columns[data-v-420c1582]{padding-right:0;padding-left:0}.expanded.row .small-collapse.row[data-v-420c1582],.small-collapse .row[data-v-420c1582]{margin-right:0;margin-left:0}.small-uncollapse>.column[data-v-420c1582],.small-uncollapse>.columns[data-v-420c1582]{padding-right:.625rem;padding-left:.625rem}.small-centered[data-v-420c1582]{margin-right:auto;margin-left:auto}.small-centered[data-v-420c1582],.small-centered[data-v-420c1582]:last-child:not(:first-child){float:none;clear:both}.small-pull-0[data-v-420c1582],.small-push-0[data-v-420c1582],.small-uncentered[data-v-420c1582]{position:static;float:left;margin-right:0;margin-left:0}@media print,screen and (min-width:40em){.medium-1[data-v-420c1582]{width:8.33333%}.medium-push-1[data-v-420c1582]{position:relative;left:8.33333%}.medium-pull-1[data-v-420c1582]{position:relative;left:-8.33333%}.medium-offset-0[data-v-420c1582]{margin-left:0}.medium-2[data-v-420c1582]{width:16.66667%}.medium-push-2[data-v-420c1582]{position:relative;left:16.66667%}.medium-pull-2[data-v-420c1582]{position:relative;left:-16.66667%}.medium-offset-1[data-v-420c1582]{margin-left:8.33333%}.medium-3[data-v-420c1582]{width:25%}.medium-push-3[data-v-420c1582]{position:relative;left:25%}.medium-pull-3[data-v-420c1582]{position:relative;left:-25%}.medium-offset-2[data-v-420c1582]{margin-left:16.66667%}.medium-4[data-v-420c1582]{width:33.33333%}.medium-push-4[data-v-420c1582]{position:relative;left:33.33333%}.medium-pull-4[data-v-420c1582]{position:relative;left:-33.33333%}.medium-offset-3[data-v-420c1582]{margin-left:25%}.medium-5[data-v-420c1582]{width:41.66667%}.medium-push-5[data-v-420c1582]{position:relative;left:41.66667%}.medium-pull-5[data-v-420c1582]{position:relative;left:-41.66667%}.medium-offset-4[data-v-420c1582]{margin-left:33.33333%}.medium-6[data-v-420c1582]{width:50%}.medium-push-6[data-v-420c1582]{position:relative;left:50%}.medium-pull-6[data-v-420c1582]{position:relative;left:-50%}.medium-offset-5[data-v-420c1582]{margin-left:41.66667%}.medium-7[data-v-420c1582]{width:58.33333%}.medium-push-7[data-v-420c1582]{position:relative;left:58.33333%}.medium-pull-7[data-v-420c1582]{position:relative;left:-58.33333%}.medium-offset-6[data-v-420c1582]{margin-left:50%}.medium-8[data-v-420c1582]{width:66.66667%}.medium-push-8[data-v-420c1582]{position:relative;left:66.66667%}.medium-pull-8[data-v-420c1582]{position:relative;left:-66.66667%}.medium-offset-7[data-v-420c1582]{margin-left:58.33333%}.medium-9[data-v-420c1582]{width:75%}.medium-push-9[data-v-420c1582]{position:relative;left:75%}.medium-pull-9[data-v-420c1582]{position:relative;left:-75%}.medium-offset-8[data-v-420c1582]{margin-left:66.66667%}.medium-10[data-v-420c1582]{width:83.33333%}.medium-push-10[data-v-420c1582]{position:relative;left:83.33333%}.medium-pull-10[data-v-420c1582]{position:relative;left:-83.33333%}.medium-offset-9[data-v-420c1582]{margin-left:75%}.medium-11[data-v-420c1582]{width:91.66667%}.medium-push-11[data-v-420c1582]{position:relative;left:91.66667%}.medium-pull-11[data-v-420c1582]{position:relative;left:-91.66667%}.medium-offset-10[data-v-420c1582]{margin-left:83.33333%}.medium-12[data-v-420c1582]{width:100%}.medium-offset-11[data-v-420c1582]{margin-left:91.66667%}.medium-up-1>.column[data-v-420c1582],.medium-up-1>.columns[data-v-420c1582]{float:left;width:100%}.medium-up-1>.column[data-v-420c1582]:nth-of-type(1n),.medium-up-1>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.medium-up-1>.column[data-v-420c1582]:nth-of-type(1n+1),.medium-up-1>.columns[data-v-420c1582]:nth-of-type(1n+1){clear:both}.medium-up-1>.column[data-v-420c1582]:last-child,.medium-up-1>.columns[data-v-420c1582]:last-child{float:left}.medium-up-2>.column[data-v-420c1582],.medium-up-2>.columns[data-v-420c1582]{float:left;width:50%}.medium-up-2>.column[data-v-420c1582]:nth-of-type(1n),.medium-up-2>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.medium-up-2>.column[data-v-420c1582]:nth-of-type(odd),.medium-up-2>.columns[data-v-420c1582]:nth-of-type(odd){clear:both}.medium-up-2>.column[data-v-420c1582]:last-child,.medium-up-2>.columns[data-v-420c1582]:last-child{float:left}.medium-up-3>.column[data-v-420c1582],.medium-up-3>.columns[data-v-420c1582]{float:left;width:33.33333%}.medium-up-3>.column[data-v-420c1582]:nth-of-type(1n),.medium-up-3>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.medium-up-3>.column[data-v-420c1582]:nth-of-type(3n+1),.medium-up-3>.columns[data-v-420c1582]:nth-of-type(3n+1){clear:both}.medium-up-3>.column[data-v-420c1582]:last-child,.medium-up-3>.columns[data-v-420c1582]:last-child{float:left}.medium-up-4>.column[data-v-420c1582],.medium-up-4>.columns[data-v-420c1582]{float:left;width:25%}.medium-up-4>.column[data-v-420c1582]:nth-of-type(1n),.medium-up-4>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.medium-up-4>.column[data-v-420c1582]:nth-of-type(4n+1),.medium-up-4>.columns[data-v-420c1582]:nth-of-type(4n+1){clear:both}.medium-up-4>.column[data-v-420c1582]:last-child,.medium-up-4>.columns[data-v-420c1582]:last-child{float:left}.medium-up-5>.column[data-v-420c1582],.medium-up-5>.columns[data-v-420c1582]{float:left;width:20%}.medium-up-5>.column[data-v-420c1582]:nth-of-type(1n),.medium-up-5>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.medium-up-5>.column[data-v-420c1582]:nth-of-type(5n+1),.medium-up-5>.columns[data-v-420c1582]:nth-of-type(5n+1){clear:both}.medium-up-5>.column[data-v-420c1582]:last-child,.medium-up-5>.columns[data-v-420c1582]:last-child{float:left}.medium-up-6>.column[data-v-420c1582],.medium-up-6>.columns[data-v-420c1582]{float:left;width:16.66667%}.medium-up-6>.column[data-v-420c1582]:nth-of-type(1n),.medium-up-6>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.medium-up-6>.column[data-v-420c1582]:nth-of-type(6n+1),.medium-up-6>.columns[data-v-420c1582]:nth-of-type(6n+1){clear:both}.medium-up-6>.column[data-v-420c1582]:last-child,.medium-up-6>.columns[data-v-420c1582]:last-child{float:left}.medium-up-7>.column[data-v-420c1582],.medium-up-7>.columns[data-v-420c1582]{float:left;width:14.28571%}.medium-up-7>.column[data-v-420c1582]:nth-of-type(1n),.medium-up-7>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.medium-up-7>.column[data-v-420c1582]:nth-of-type(7n+1),.medium-up-7>.columns[data-v-420c1582]:nth-of-type(7n+1){clear:both}.medium-up-7>.column[data-v-420c1582]:last-child,.medium-up-7>.columns[data-v-420c1582]:last-child{float:left}.medium-up-8>.column[data-v-420c1582],.medium-up-8>.columns[data-v-420c1582]{float:left;width:12.5%}.medium-up-8>.column[data-v-420c1582]:nth-of-type(1n),.medium-up-8>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.medium-up-8>.column[data-v-420c1582]:nth-of-type(8n+1),.medium-up-8>.columns[data-v-420c1582]:nth-of-type(8n+1){clear:both}.medium-up-8>.column[data-v-420c1582]:last-child,.medium-up-8>.columns[data-v-420c1582]:last-child{float:left}.medium-collapse>.column[data-v-420c1582],.medium-collapse>.columns[data-v-420c1582]{padding-right:0;padding-left:0}.expanded.row .medium-collapse.row[data-v-420c1582],.medium-collapse .row[data-v-420c1582]{margin-right:0;margin-left:0}.medium-uncollapse>.column[data-v-420c1582],.medium-uncollapse>.columns[data-v-420c1582]{padding-right:.9375rem;padding-left:.9375rem}.medium-centered[data-v-420c1582]{margin-right:auto;margin-left:auto}.medium-centered[data-v-420c1582],.medium-centered[data-v-420c1582]:last-child:not(:first-child){float:none;clear:both}.medium-pull-0[data-v-420c1582],.medium-push-0[data-v-420c1582],.medium-uncentered[data-v-420c1582]{position:static;float:left;margin-right:0;margin-left:0}}@media print,screen and (min-width:64em){.large-1[data-v-420c1582]{width:8.33333%}.large-push-1[data-v-420c1582]{position:relative;left:8.33333%}.large-pull-1[data-v-420c1582]{position:relative;left:-8.33333%}.large-offset-0[data-v-420c1582]{margin-left:0}.large-2[data-v-420c1582]{width:16.66667%}.large-push-2[data-v-420c1582]{position:relative;left:16.66667%}.large-pull-2[data-v-420c1582]{position:relative;left:-16.66667%}.large-offset-1[data-v-420c1582]{margin-left:8.33333%}.large-3[data-v-420c1582]{width:25%}.large-push-3[data-v-420c1582]{position:relative;left:25%}.large-pull-3[data-v-420c1582]{position:relative;left:-25%}.large-offset-2[data-v-420c1582]{margin-left:16.66667%}.large-4[data-v-420c1582]{width:33.33333%}.large-push-4[data-v-420c1582]{position:relative;left:33.33333%}.large-pull-4[data-v-420c1582]{position:relative;left:-33.33333%}.large-offset-3[data-v-420c1582]{margin-left:25%}.large-5[data-v-420c1582]{width:41.66667%}.large-push-5[data-v-420c1582]{position:relative;left:41.66667%}.large-pull-5[data-v-420c1582]{position:relative;left:-41.66667%}.large-offset-4[data-v-420c1582]{margin-left:33.33333%}.large-6[data-v-420c1582]{width:50%}.large-push-6[data-v-420c1582]{position:relative;left:50%}.large-pull-6[data-v-420c1582]{position:relative;left:-50%}.large-offset-5[data-v-420c1582]{margin-left:41.66667%}.large-7[data-v-420c1582]{width:58.33333%}.large-push-7[data-v-420c1582]{position:relative;left:58.33333%}.large-pull-7[data-v-420c1582]{position:relative;left:-58.33333%}.large-offset-6[data-v-420c1582]{margin-left:50%}.large-8[data-v-420c1582]{width:66.66667%}.large-push-8[data-v-420c1582]{position:relative;left:66.66667%}.large-pull-8[data-v-420c1582]{position:relative;left:-66.66667%}.large-offset-7[data-v-420c1582]{margin-left:58.33333%}.large-9[data-v-420c1582]{width:75%}.large-push-9[data-v-420c1582]{position:relative;left:75%}.large-pull-9[data-v-420c1582]{position:relative;left:-75%}.large-offset-8[data-v-420c1582]{margin-left:66.66667%}.large-10[data-v-420c1582]{width:83.33333%}.large-push-10[data-v-420c1582]{position:relative;left:83.33333%}.large-pull-10[data-v-420c1582]{position:relative;left:-83.33333%}.large-offset-9[data-v-420c1582]{margin-left:75%}.large-11[data-v-420c1582]{width:91.66667%}.large-push-11[data-v-420c1582]{position:relative;left:91.66667%}.large-pull-11[data-v-420c1582]{position:relative;left:-91.66667%}.large-offset-10[data-v-420c1582]{margin-left:83.33333%}.large-12[data-v-420c1582]{width:100%}.large-offset-11[data-v-420c1582]{margin-left:91.66667%}.large-up-1>.column[data-v-420c1582],.large-up-1>.columns[data-v-420c1582]{float:left;width:100%}.large-up-1>.column[data-v-420c1582]:nth-of-type(1n),.large-up-1>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.large-up-1>.column[data-v-420c1582]:nth-of-type(1n+1),.large-up-1>.columns[data-v-420c1582]:nth-of-type(1n+1){clear:both}.large-up-1>.column[data-v-420c1582]:last-child,.large-up-1>.columns[data-v-420c1582]:last-child{float:left}.large-up-2>.column[data-v-420c1582],.large-up-2>.columns[data-v-420c1582]{float:left;width:50%}.large-up-2>.column[data-v-420c1582]:nth-of-type(1n),.large-up-2>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.large-up-2>.column[data-v-420c1582]:nth-of-type(odd),.large-up-2>.columns[data-v-420c1582]:nth-of-type(odd){clear:both}.large-up-2>.column[data-v-420c1582]:last-child,.large-up-2>.columns[data-v-420c1582]:last-child{float:left}.large-up-3>.column[data-v-420c1582],.large-up-3>.columns[data-v-420c1582]{float:left;width:33.33333%}.large-up-3>.column[data-v-420c1582]:nth-of-type(1n),.large-up-3>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.large-up-3>.column[data-v-420c1582]:nth-of-type(3n+1),.large-up-3>.columns[data-v-420c1582]:nth-of-type(3n+1){clear:both}.large-up-3>.column[data-v-420c1582]:last-child,.large-up-3>.columns[data-v-420c1582]:last-child{float:left}.large-up-4>.column[data-v-420c1582],.large-up-4>.columns[data-v-420c1582]{float:left;width:25%}.large-up-4>.column[data-v-420c1582]:nth-of-type(1n),.large-up-4>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.large-up-4>.column[data-v-420c1582]:nth-of-type(4n+1),.large-up-4>.columns[data-v-420c1582]:nth-of-type(4n+1){clear:both}.large-up-4>.column[data-v-420c1582]:last-child,.large-up-4>.columns[data-v-420c1582]:last-child{float:left}.large-up-5>.column[data-v-420c1582],.large-up-5>.columns[data-v-420c1582]{float:left;width:20%}.large-up-5>.column[data-v-420c1582]:nth-of-type(1n),.large-up-5>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.large-up-5>.column[data-v-420c1582]:nth-of-type(5n+1),.large-up-5>.columns[data-v-420c1582]:nth-of-type(5n+1){clear:both}.large-up-5>.column[data-v-420c1582]:last-child,.large-up-5>.columns[data-v-420c1582]:last-child{float:left}.large-up-6>.column[data-v-420c1582],.large-up-6>.columns[data-v-420c1582]{float:left;width:16.66667%}.large-up-6>.column[data-v-420c1582]:nth-of-type(1n),.large-up-6>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.large-up-6>.column[data-v-420c1582]:nth-of-type(6n+1),.large-up-6>.columns[data-v-420c1582]:nth-of-type(6n+1){clear:both}.large-up-6>.column[data-v-420c1582]:last-child,.large-up-6>.columns[data-v-420c1582]:last-child{float:left}.large-up-7>.column[data-v-420c1582],.large-up-7>.columns[data-v-420c1582]{float:left;width:14.28571%}.large-up-7>.column[data-v-420c1582]:nth-of-type(1n),.large-up-7>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.large-up-7>.column[data-v-420c1582]:nth-of-type(7n+1),.large-up-7>.columns[data-v-420c1582]:nth-of-type(7n+1){clear:both}.large-up-7>.column[data-v-420c1582]:last-child,.large-up-7>.columns[data-v-420c1582]:last-child{float:left}.large-up-8>.column[data-v-420c1582],.large-up-8>.columns[data-v-420c1582]{float:left;width:12.5%}.large-up-8>.column[data-v-420c1582]:nth-of-type(1n),.large-up-8>.columns[data-v-420c1582]:nth-of-type(1n){clear:none}.large-up-8>.column[data-v-420c1582]:nth-of-type(8n+1),.large-up-8>.columns[data-v-420c1582]:nth-of-type(8n+1){clear:both}.large-up-8>.column[data-v-420c1582]:last-child,.large-up-8>.columns[data-v-420c1582]:last-child{float:left}.large-collapse>.column[data-v-420c1582],.large-collapse>.columns[data-v-420c1582]{padding-right:0;padding-left:0}.expanded.row .large-collapse.row[data-v-420c1582],.large-collapse .row[data-v-420c1582]{margin-right:0;margin-left:0}.large-uncollapse>.column[data-v-420c1582],.large-uncollapse>.columns[data-v-420c1582]{padding-right:.9375rem;padding-left:.9375rem}.large-centered[data-v-420c1582]{margin-right:auto;margin-left:auto}.large-centered[data-v-420c1582],.large-centered[data-v-420c1582]:last-child:not(:first-child){float:none;clear:both}.large-pull-0[data-v-420c1582],.large-push-0[data-v-420c1582],.large-uncentered[data-v-420c1582]{position:static;float:left;margin-right:0;margin-left:0}}.column-block[data-v-420c1582]{margin-bottom:1.25rem}.column-block>[data-v-420c1582]:last-child{margin-bottom:0}@media print,screen and (min-width:40em){.column-block[data-v-420c1582]{margin-bottom:1.875rem}.column-block>[data-v-420c1582]:last-child{margin-bottom:0}}.close-button[data-v-420c1582]{position:absolute;color:#8a8a8a;cursor:pointer}[data-whatinput=mouse] .close-button[data-v-420c1582]{outline:0}.close-button[data-v-420c1582]:focus,.close-button[data-v-420c1582]:hover{color:#0a0a0a}.close-button.small[data-v-420c1582]{right:.66rem;top:.33em;font-size:1.5em;line-height:1}.close-button.medium[data-v-420c1582],.close-button[data-v-420c1582]{right:1rem;top:.5rem;font-size:2em;line-height:1}.thumbnail[data-v-420c1582]{display:inline-block;max-width:100%;margin-bottom:1rem;border:4px solid #fefefe;border-radius:0;box-shadow:0 0 0 1px hsla(0,0%,4%,.2);line-height:0}a.thumbnail[data-v-420c1582]{transition:box-shadow .2s ease-out}a.thumbnail[data-v-420c1582]:focus,a.thumbnail[data-v-420c1582]:hover{box-shadow:0 0 6px 1px rgba(23,121,186,.5)}a.thumbnail image[data-v-420c1582]{box-shadow:none}", ""]);

// exports


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".face[data-v-ddf0b578]{position:relative}.face img[data-v-ddf0b578]{max-width:100%!important;margin-left:auto!important;margin-right:auto;display:block}.imgContainer[data-v-ddf0b578]{background-color:#45818e;width:100%;height:0;padding-bottom:100%}.imgContainer img[data-v-ddf0b578]{width:100%;position:absolute}.title.close.button[data-v-ddf0b578],.title.top[data-v-ddf0b578]{display:none}@media print,screen and (min-width:64em){p.description[data-v-ddf0b578]{display:block;position:absolute;top:0;bottom:0;margin:0;padding:10px;color:#fff;background-color:rgba(0,0,0,.6);height:100%;width:100%;font-size:11px;visibility:hidden}p.description.titleDescription[data-v-ddf0b578]{font-size:20px;vertical-align:middle;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;display:-ms-flexbox;display:flex}.face:hover p.description[data-v-ddf0b578]{visibility:visible}}@media print,screen and (max-width:63.999em){p.description[data-v-ddf0b578]{display:none}img[data-v-ddf0b578]{cursor:pointer}.popupActive .title.top[data-v-ddf0b578]{display:block}.popupActive .title.bottom[data-v-ddf0b578]{display:none}.popupActive .title.close.button[data-v-ddf0b578]{display:block}.popupActive .imgContainer[data-v-ddf0b578]{background-color:transparent;height:30vh;width:auto;padding:0}.popupActive .imgContainer img[data-v-ddf0b578]{height:30vh;width:auto;position:relative}.popupActive p.description[data-v-ddf0b578]{display:block}.popupActive p.description.titleDescription[data-v-ddf0b578]{font-size:20px;vertical-align:middle;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;display:-ms-flexbox;display:flex}.popupActive.container[data-v-ddf0b578]{z-index:9999;width:100%;height:100%;position:fixed;top:0;left:0;background-color:#fff;padding:10px;padding-top:50px;overflow:auto}}.button[data-v-ddf0b578]{cursor:pointer;border:2px;border-style:solid;padding:2px}.close.button[data-v-ddf0b578]{position:absolute;right:20px}.title[data-v-ddf0b578]{text-align:center}", ""]);

// exports


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __webpack_require__(0);
var vue_class_component_1 = __webpack_require__(4);
var Face_vue_1 = __webpack_require__(11);
var FaceBlockGrid = /** @class */ (function (_super) {
    __extends(FaceBlockGrid, _super);
    function FaceBlockGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FaceBlockGrid = __decorate([
        vue_class_component_1.default({
            props: {
                faces: Array,
                titleDescription: Boolean,
            },
            components: { Face: Face_vue_1.default }
        })
    ], FaceBlockGrid);
    return FaceBlockGrid;
}(vue_1.default));
exports.default = FaceBlockGrid;
;


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __webpack_require__(0);
var vue_class_component_1 = __webpack_require__(4);
var textFit_1 = __webpack_require__(10);
var Face = /** @class */ (function (_super) {
    __extends(Face, _super);
    function Face() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popupActive = false;
        return _this;
    }
    Face.prototype.mounted = function () {
        // Don't do this for titleDescriptions which are big anyway.
        if (!this.$props.titleDescription) {
            textFit_1.textFit(this.$el.getElementsByClassName("description"), {
                minFontSize: 10,
            });
        }
        ;
    };
    Face = __decorate([
        vue_class_component_1.default({
            props: {
                face: Object,
                titleDescription: Boolean,
            }
        })
    ], Face);
    return Face;
}(vue_1.default));
exports.default = Face;
;


/***/ })

},[26]);


// WEBPACK FOOTER //
// static/js/in_loving_memory.js